// extracted by mini-css-extract-plugin
module.exports = {"component":"CartTyre_component__5_9W7"};